import trans from "../../../../utils";

const vehicleReportsTypes = [
	{
		name: trans("Vehicles Trips Report"),
		shortname: "vehiclestrips",
		description: trans("Vehicles Trips Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESTRIPSREPORT",
	},
	{
		name: trans("Speed Report"),
		shortname: "speed",
		description: trans("Speed Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESSPEEDREPORT",
	},
	/*{
    name: "Alarms Report",
    shortname: "alarm",
    description:
      "This report will provide information on the alarms for each vehicle.",
    reportType: "Vehicles",
  },*/
	{
		name: trans("Stop Report"),
		shortname: "stop",
		description: trans("Stop Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESSTOPREPORT",
	},
	{
		name: trans("Distance Report"),
		shortname: "distance",
		description: trans("Distance Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESDISTANCEREPORT",
	},
	/**  {
     name: "Ignition Report",
     shortname: "ignition",
     description:
       "This report will provide the history of vehicle ignition events.",
     reportType: "Vehicles",
   },*/
	/**  {
     name: "Door Open Report",
     shortname: "door",
     description:
       "This report will provide the history of vehicle door openings.",
     reportType: "Vehicles",
   },*/
	{
		name: trans("Device Behavior Report"),
		shortname: "devicebehavior",
		description: trans("Route Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESDEVICEBEHAVIORREPORT",
	},
	{
		name: trans("Fuel Report"),
		shortname: "fuel",
		description: trans("Fuel Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESFUELREPORT",
	},
	/** {
     name: "Engine Control Log",
     description: "This report will provide a log of engine control activities.",
     reportType: "Vehicles",
   },
   {
     name: "Idle Report",
     description: "This report will provide the idle times for all vehicles.",
     reportType: "Vehicles",
   },*/
	{
		name: trans("Odometer Report"),
		shortname: "odometer",
		description: trans("Odometer Report des"),
		reportType: "Vehicles",
		moduleKey: "REPORTSVEHICLESODOMETERREPORT",
	},
	/** {
     name: "Vehicles Documents Report",
     description:
       "This report will provide all the official documents of the vehicles along with their expiration dates.",
     reportType: "Vehicles",
   },
   {
     name: "Temperature Report",
     description:
       "This report will give you complete temperature data updated every minute.",
     reportType: "Vehicles",
   },
   {
     name: "Weight Report",
     description:
       "This report will give you complete weight data updated every minute.",
     reportType: "Vehicles",
   },*/
];

const maintenanceReportsypes = [
	{
		name: "Maintenance Report",
		description:
			"This report will provide you with information about the latest maintenance, upcoming maintenance, its type, and other information.",
		reportType: "Maintenance",
	},
	{
		name: "Cost Report",
		description:
			"This report will compare the costs of all vehicles against each other.",
		reportType: "Maintenance",
	},
	{
		name: "Parts Report",
		description:
			"This report will provide details of the parts used in previous maintenance, along with their costs.",
		reportType: "Maintenance",
	},
];

const workforceReportsTypes = [
	{
		name: trans("Field Staff Productivity & Workload Report"),
		description: trans(
			"showing tasks completed, efficiency, and workload distribution across staff.",
		),
		reportType: "fieldservices",
		shortname: "productivity",
		moduleKey: "REPORTSFSFSPRODUCTIVITY",
	},
	{
		name: trans("Tasks Performance Report"),
		description: trans(
			"Enabling supervisors to assess task efficiency and detect delays to improve productivity and service quality.",
		),
		reportType: "fieldservices",
		shortname: "efficiency",
		moduleKey: "REPORTSFSTASKSPERFORMANCE",
	},
	{
		name: trans("Service Request Report"),
		description: trans(
			"Empowering management with data-driven insights to boost efficiency, productivity, client satisfaction, and overall performance.",
		),
		reportType: "fieldservices",
		shortname: "requests",
		moduleKey: "REPORTSFSSERVICEREQUEST",
	},
	{
		name: trans("shift Compliance"),
		description: trans(
			"Empowering management with data-driven insights to boost efficiency, productivity, client satisfaction, and overall performance.",
		),
		reportType: "fieldservices",
		shortname: "attendance",
		moduleKey: "REPORTSFSSHIFTCOMPLIANCE",
	},
	{
		name: trans("Attendance Report"),
		description: trans(
			"Empowering management with data-driven insights to boost efficiency, productivity, client satisfaction, and overall performance.",
		),
		reportType: "fieldservices",
		shortname: "dailyAttendance",
		moduleKey: "REPORTSFSATTENDANCEREPORT",
	},
	{
		name: trans("Device Usage Report"),
		description: trans("showing the devices usage by the field staff."),
		reportType: "fieldservices",
		shortname: "deviceAssignment",
		moduleKey: "REPORTSFSDEVICEUSAGEREPORT",
	},
	{
		name: trans("Shelf & Inventory Report"),
		description: trans(
			"Monitor shelf availability, out-of-stock rates, and product states across stores.",
		),
		reportType: "inventory",
		shortname: "shelfAvailability",
		moduleKey: "REPORTSFSDEVICEUSAGEREPORT",
	},
	{
		name: trans("Product Expiration Report"),
		description: trans(
			"Track products nearing or past their expiry date across all locations.",
		),
		reportType: "inventory",
		shortname: "productExpiration",
		moduleKey: "REPORTSFSDEVICEUSAGEREPORT",
	},
	{
		name: trans("Shelf Movement Report"),
		description: trans(
			"Report provides visibility into shelf inventory changes during a selected period.",
		),
		reportType: "inventory",
		shortname: "shelfMovement",
		moduleKey: "REPORTSFSDEVICEUSAGEREPORT",
	},
];

// const inventoryReportsTypes = [
//   {
//     name: trans("Shelf & Inventory Report"),
//     description: trans(
//       "Monitor shelf availability, out-of-stock rates, and product states across stores.",
//     ),
//     reportType: "inventory",
//     shortname: "shelfAvailability",
//     moduleKey: "REPORTSINVENTORYSHELFAVAILABILITY",
//   },
// ];

const reportsDataMap = {
	vehicle: vehicleReportsTypes,
	maintenance: maintenanceReportsypes,
	fieldservices: workforceReportsTypes,
	//   inventory: inventoryReportsTypes,
};

export {
	vehicleReportsTypes,
	maintenanceReportsypes,
	workforceReportsTypes,
	//   inventoryReportsTypes,
	reportsDataMap,
};
